import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAsyncService from '../../../../hooks/useAsyncService'
import dayjs from 'dayjs'
import {
  searchLocationData,
  LocationSearchRequest
} from '../../../../services/endpoints/data'
import { LoadIndicator } from 'devextreme-react'
import ICSErrorCard from '../../../../components/ICSErrorCard/ICSErrorCard'
import LocationMapModal from './LocationsModal'
import { DefaultState } from '../../../../types'
import { fetchServerSettings } from '../../../../redux/slices'

type LocationMapWrapperProps = {
  isOpen: boolean
  onClose: () => void
  vehicleName: string
  request: LocationSearchRequest
}

const formatRequest = (req: LocationSearchRequest): LocationSearchRequest => ({
  ...req,
  startDate: dayjs.utc(req.startDate).format('YYYY/MM/DD HH:mm:ss'),
  endDate: dayjs.utc(req.endDate).format('YYYY/MM/DD HH:mm:ss')
})

const LocationMapWrapper: React.FC<LocationMapWrapperProps> = ({
  isOpen,
  onClose,
  vehicleName,
  request
}) => {
  const dispatch = useDispatch()

  const settings = useSelector((state: DefaultState) => state.server.settings)
  const googleMapsApiKey =
    settings.find((s) => s.what === 'googleMapsApiKey')?.val || ''

  const { serviceLoading, serviceValue, serviceError, setServiceArgs } =
    useAsyncService({
      serviceCall: searchLocationData,
      delay: 0,
      initialArgs: null
    })

  // Fetch server settings if modal opens and they haven't been loaded
  useEffect(() => {
    if (isOpen && settings.length === 0) {
      dispatch(fetchServerSettings())
    }
  }, [isOpen, settings.length, dispatch])

  useEffect(() => {
    if (isOpen) {
      setServiceArgs(formatRequest(request))
    }
  }, [isOpen, request])

  if (!isOpen) return null

  const GetBody = () => {
    if (serviceError) {
      return <ICSErrorCard code={'error'} message={serviceError} fields={[]} />
    } else if (serviceLoading || !serviceValue) {
      return <LoadIndicator />
    } else {
      return (
        <LocationMapModal
          isOpen={true}
          onClose={onClose}
          vehicleName={vehicleName}
          locations={serviceValue.data}
          googleMapsApiKey={googleMapsApiKey}
        />
      )
    }
  }

  return <GetBody />
}

export default LocationMapWrapper
